import { useContext } from 'react';

import { TeamsSettingContext } from '../Contexts/index';

const useTeamsSettings = () => {
  const context = useContext(TeamsSettingContext);

  return context;
};

export default useTeamsSettings;
